<div class="wrap" [ngClass]="{ 'single-date': isSingalDate }">
  <div class="date-input-wrap" *ngIf="!isSingalDate">
    <div class="date-image-with-icon">
      <img src="/assets/images/calendar-icon.svg" />
      <input
        class="date-input"
        placeholder="{{ 'filter.dateRangeFilter.fromDate' | translate }}"
        [value]="(!isCustomDateFromNull ? customDateFrom : null) |queDate" readonly
      />
    </div>
    <span> - </span>
    <div class="date-image-with-icon">
      <img src="/assets/images/calendar-icon.svg" />
      <input
        class="date-input"
        placeholder="{{ 'filter.dateRangeFilter.toDate' | translate }}"
        value="{{ customDateTo |queDate }}" readonly
      />
    </div>
  </div>
  <div class="dual-calendars-wrapper">
    <swiper-container
      #swiper
      slides-per-view="1"
      (swiperslidechange)="onSlideChange($event)"
      class="swiper-holder"
    >
      <swiper-slide
        *ngFor="let month of rangeMonthNames; let i = index"
      >
        <div class="calendar" [ngClass]="{ hide: !showDayPicker }">
          <div class="calendar__opts">
            <!-- <div class="wrap-arrow"> -->
            <div
              class="swiper-button left-arrow"
              *ngIf="lang=='en'?!swiperIsEnd:(!swiperIsBeginning && !begin)"
              (click)="moveSlides('next')"
            >
              <img src="/assets/images/arrow.svg" />
            </div>
            <div
              class="swiper-button right-arrow"
              *ngIf="lang=='en'?(!swiperIsBeginning && !begin):!swiperIsEnd"
              (click)="moveSlides('prev')"
            >
              <img src="/assets/images/arrow.svg" class="right" />
            </div>
            <!-- </div> -->

            <div class="custom-select">
            <div
                class="filter-img-wrapper"
                #months
                (click)=" scrollToSelectedMonth(i);isMonthsToSelectOpen[i] = true;"
              >
                <h5
                  class="small"
                  translate
                  [translateParams]="{ item: valueOfMonthSelect }"
                >
                  filter.monthName
                </h5>
                <img src="/assets/images/arrow-down-black.svg" />
              </div>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="months"
                [cdkConnectedOverlayHasBackdrop]="true"
                (backdropClick)="isMonthsToSelectOpen[i] = false"
                [cdkConnectedOverlayOpen]="isMonthsToSelectOpen[i]"
                cdkConnectedOverlayBackdropClass="backdrop-selection"
                [cdkConnectedOverlayPositions]="positonArea"
              >
                <div class="type-list-wrapper" #monthList>
                  <div
                    [ngClass]="{
                      active: m === valueOfMonthSelect ? true : false
                    }"
                    class="type-list-item tooltip-specific-release-button"
                    *ngFor="let m of monthDic"
                    (click)="selectMonthFromSelect(m,i)"
                  >
                    <h5 class="small" translate [translateParams]="{ item: m }">
                      filter.monthName
                    </h5>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="custom-select">
              <div
                class="filter-img-wrapper"
                #years
                (click)="scrollToSelectedYear(i);isYearsToSelectOpen[i] = true ;"
              >
                <h5 class="small">
                  {{ valueOfYearSelect }}
                </h5>
                <img src="/assets/images/arrow-down-black.svg" />
              </div>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="years"
                [cdkConnectedOverlayHasBackdrop]="true"
                (backdropClick)="isYearsToSelectOpen[i] = false"
                [cdkConnectedOverlayOpen]="isYearsToSelectOpen[i]"
                cdkConnectedOverlayBackdropClass="backdrop-selection"
                [cdkConnectedOverlayPositions]="positonArea"
              >
                <div class="type-list-wrapper tooltip-specific-release-button" #yearList>
                  <div
                    [ngClass]="{
                      active: y === valueOfYearSelect ? true : false
                    }"
                    class="type-list-item"
                    *ngFor="let y of yearNames"
                    (click)="selectYear(y.toString(), valueOfMonthSelect,i)"
                  >
                    <h5 class="small">{{ y }}</h5>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="calendar__body">
            <div class="calendar__days">
              <div>
                <h6 translate>calendar.su</h6>
              </div>
              <div>
                <h6 translate>calendar.mo</h6>
              </div>
              <div>
                <h6 translate>calendar.tu</h6>
              </div>
              <div>
                <h6 translate>calendar.we</h6>
              </div>
              <div>
                <h6 translate>calendar.th</h6>
              </div>
              <div>
                <h6 translate>calendar.fr</h6>
              </div>
              <div>
                <h6 translate>calendar.sa</h6>
              </div>
            </div>
            <div class="calendar__dates">
              <div
                *ngFor="let day of month.days"
                class="calendar__date"
                (click)="selectDatesForRange(day)"
                [ngClass]="{
                'calendar__date--last-date calendar__date--range-end':
                  day.isEnd && !isSingalDate,
                'calendar__date--first-date calendar__date--range-start':
                  day.isStart && !isSingalDate,
                'calendar__date--todayDate': day.isToday,
                'calendar__date--first-date calendar__date--range-start--isCustomDateFromNull': day.isStart && !isSingalDate&&isCustomDateFromNull,
                'calendar__date--dateSelected': day.isSelected && isSingalDate,
                'calendar__date--isDisable': day.isDisable,
                'calendar__date--grey': !day.isRelatedToMonth ,
                'calendar__date--singal-date':isSingalDate && day.isSingalDateSelected,
                'selected-range': isWithinCustomRange(day.date),
                'selected-range--range-end':
                isWithinCustomRange(day.date) && day.isEnd && !isSingalDate,
                  'selected-range--range-start':
                  isWithinCustomRange(day.date) && day.isStart && !isSingalDate ,
              }"
              >
                <span>{{ day.date.getDate() }}</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</div>
